module.exports = "ul {\n  list-style-type: none; }\n"